// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__LAMhF","col":"styles_col__CTb5m"};